export default {
    inquiryAndAttendance: 'คำร้องขอและการเข้างาน',
    inquiryAndAttendanceSub: 'หมายเหตุ: รูปภาพที่เกี่ยวข้องกับการเข้างานจะถูกนำออกหลังจากผ่านไปแล้ว 3 เดือน',
    inquiry: 'คำร้องขอ',
    searchByEmployeeName: 'ค้นหาจากชื่อ',
    search: 'ค้นหา',
    allStatus: 'ทุกสถานะ',
    pending: 'กำลังดำเนินการ',
    approve: 'อนุมัติ',
    reject: 'ไม่อนุมัติ',
    employeeName: 'ชื่อ - นามสกุล',
    group: 'กลุ่ม',
    department: 'แผนก',
    type: 'ประเภท',
    inquiryDate: 'วันส่งคำร้องขอ',
    period: 'ระยะการลา',
    fullDay: 'เต็มวัน',
    halfDay: 'ครึ่งวัน',
    status: 'สถานะ',
    cannotEditTheApproval: 'ไม่สามารถแก้ไขคำขอที่อนุมัติแล้วได้',
    cannotEditTheRejected: 'ไม่สามารถแก้ไขคำขอที่ถูกยกเลิกแล้วได้',
    statusAttendance: 'สถานะเข้างาน',
    manageAttendance: 'จัดการข้อมูลการลงเวลา',
    manageAttendanceRequest: 'จัดการคำขอข้อมูลการลงเวลา',
    overtimeRequest: 'คำขอ OT',
    punchLog: 'บันทึกการเข้าออก',
    checkInLocation: 'สถานที่',
    forgotCheckInReq: 'คำขอลงเวลาย้อนหลัง'
}
